import React from "react";
import { Layout } from "antd";
import style from "css/admin/component.module.css";
import axios from "axios";
import { Cookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { closeAlert, openConfirm } from "../../redux/slices/alertSlice";
import { deleteUserInfo } from "../../redux/slices/userSlice";

function AdminHeader() {
  //dispatch
  const dispatch = useDispatch();
  const userNm = useSelector((state) => state.user?.userNm) || "";

  //navigate
  const navigate = useNavigate();

  const logoutHandler = () => {
    axios.post("/user/logout").then((res) => {
      if (res.status === 200) {
        const authNm = process.env.REACT_APP_AUTH_TOKEN;
        const refreshNm = process.env.REACT_APP_REFRESH_TOKEN;
        const domain = process.env.REACT_APP_DOMAIN;
        const cookies = new Cookies();

        cookies.remove(authNm, { path: "/" });
        cookies.remove(refreshNm, { path: "/" });
        cookies.remove(authNm, { path: "/", domain: domain });
        cookies.remove(refreshNm, { path: "/", domain: domain });
        dispatch(deleteUserInfo());
        navigate(process.env.REACT_APP_CLIENT_URL + "admin");
      }
    });
  };

  return (
    <Layout.Header
      style={{
        height: 75,
        background: "#ffffff",
        borderBottom: "1px solid #c0c0c0",
        padding: "0 40px 0 31px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div className={style.header_left}>
        <img
          className={style.logo}
          src={`${process.env.REACT_APP_CLIENT_URL}icon/yonsei_logo.png`}
          alt="logo"
        />
      </div>
      <div className={style.header_right}>
        <div className={style.header_txt}>
          {(userNm ? userNm : "관리자") + " 님"}
        </div>
        <div
          className={style.logout_btn}
          onClick={() => {
            const obj = {
              title: "알림",
              content: "로그아웃 하시겠습니까?",
              submitEventHandler: () => {
                logoutHandler();
                dispatch(closeAlert());
              },
            };
            dispatch(openConfirm(obj));
          }}
        >
          <img
            src={`${process.env.REACT_APP_CLIENT_URL}icon/logout.png`}
            alt="logo"
            className={style.logout_img}
          />
        </div>
      </div>
    </Layout.Header>
  );
}

export default AdminHeader;
